module.exports = __webpack_public_path__ + "static/media/profile-header.3949c745.jpg";